import request from '@/util/request'
import localCache from '../util/localCache';

export function addSupplayPayBill(params) {
    params.token = localCache.getToken()
    return request({
        url: '/supplayPayBill',
        method: 'post',
        params
    })
}
export function updateSupplayPayBill(params) {
    params.token = localCache.getToken()
    return request({
        url: '/updateSupplayPayBill',
        method: 'post',
        params
    })
}
export function deleteSupplyPayBill(params) {
    params.token = localCache.getToken()
    return request({
        url: '/deleteSupplyPayBill',
        method: 'post',
        params
    })
}
export function getSupplayPayBillList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplayPayBillList',
        method: 'get',
        params
    })
}
export function getSupplayPayBillItemList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplayPayBillItemList',
        method: 'get',
        params
    })
}
export function getSupplierPayable(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplierPayable',
        method: 'get',
        params
    })
}
export function getSupplierSum(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplierSum',
        method: 'get',
        params
    })
}
